"use client";

import { createContext, useContext } from "react";
import type { Dispatch, SetStateAction } from "react";

interface AskSidComposerContextValue {
  isFocused: boolean;
  setIsFocused: Dispatch<SetStateAction<boolean>>;
  isCopilotReady: boolean;
}

const AskSidComposerContext = createContext<AskSidComposerContextValue>({
  isFocused: false,
  setIsFocused: () => {},
  isCopilotReady: false,
});

export const useAskSidComposer = () => useContext(AskSidComposerContext);

export default AskSidComposerContext;
